import PosicaoEstoqueView from "../../components/estoque/PosicaoEstoqueView";

export default function PosicaoEstoque() {
  return <PosicaoEstoqueView />;
}
